export type FrameMessage = Record<string, unknown> & {
    type: string
}

export function postToParent(
    message: FrameMessage,
    targetOrigin = '*'
): void {
    if (!window.parent) return
    window.parent.postMessage(message, targetOrigin)
}
